module.exports = __webpack_public_path__ + "img/scannerapppro.c869c0ea.png";